import { Button, Checkbox, Input, Popover, Radio, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { IMAGE_BASE_URL } from "../../common/Constants";

const SelAgentPopup = (props) => {
  const { setselAgentPop, selectedAgent, updateChosedAgent } = props.context;
  const [animClass, setAnimClass] = useState("invisible translate-x-[100%]");
  const [agent, setAgent] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filtAgentList, setFiltAgentList] = useState(
    selectedAgent.interestData
  );
  const handleRadChange = (e) => {
    setAgent(e.target.value);
  };
  const updateSelAgent = () => {
    updateChosedAgent(agent, selectedAgent.id, selectedAgent.providerName);
    setselAgentPop(false);
  };
  const handleSearchAgent = (e) => {
    let term = e.target.value;
    setSearchTerm(term);
    term = term.toLowerCase();
    const filteredAgents = selectedAgent.interestData.filter((item) => {
      return (
        item.agentinfo.name.toLowerCase().includes(term) ||
        String(item.adminfee).toLowerCase().includes(term) ||
        String(item.dealerCommision).toLowerCase().includes(term) ||
        String(item.yearbonusAmount).toLowerCase().includes(term)
      );
    });
    setFiltAgentList(filteredAgents);
  };
  useEffect(() => {
    document.querySelector("body").classList.add("body_scroll_hid");
    setAnimClass("visible translate-x-[0%]");
    if (selectedAgent.activeAgent) {
      setAgent(selectedAgent.activeAgent);
    } else if (selectedAgent.defaultAgent) {
      setAgent(selectedAgent.defaultAgent);
    }
    return () => {
      document.querySelector("body").classList.remove("body_scroll_hid");
      setAnimClass("invisible translate-x-[100%]");
    };
  }, []);

  const GetBonusValue = (item) => {
    const SelectItem = item;
    if (SelectItem?.qualifying_loan_amounts !== undefined && SelectItem?.qualifying_loan_amounts?.length > 0) {
      const temp = SelectItem?.qualifying_loan_amounts?.filter((it) => it?.is_applicable == 1);
      if (temp?.length > 0) {

        const bonusVal = temp[0]?.bonus_type == 1
          ? Number(temp[0].bonus) +
          "%" +
          " ($" +
          Number(temp[0].bonus_amount_earned) +
          ")"
          : "Fixed $" + Number(temp[0].bonus_amount_earned)
        return bonusVal;
      } else {
        return "N/A"
      }
    }
    else {
      return "N/A"
    }

  }



  return (
    <div
      className={`bg-black bg-opacity-50 fixed z-[999]  w-[100%] h-full left-0 top-0 test3`}
    >
      <div
        className={`w-[600px] max-w-[100%] bg-white absolute rounded-t-lg md:rounded-none bottom-0 h-[90%] md:h-[100%] right-0 max-h-screen overflow-y-scroll scBarHidden popupAnim ${animClass}`}
      >
        <div className="relative py-2 pt-14">
          <div className="absolute bg-white w-[100%] top-0">
            <div className="flex px-4 py-2 pt-4 md:px-8 md:py-4 justify-between items-center z-9 w-[100%]">
              <h3 className="text-[20px] text-[#27272B] font-bold tracking-[-.15px] capitalize">
                Select agent
              </h3>
              <div
                className="bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer"
                onClick={() => setselAgentPop(false)}
              >
                <img src="/images/x-circle.svg" className="w-5 h-5" />
              </div>
            </div>
          </div>
          <div className="px-4 md:px-6">
            <div className="mt-[15px]">
              <Input
                prefix={
                  <img
                    src="/images/search.svg"
                    alt="search"
                    className="mr-[5px]"
                  />
                }
                placeholder="Search agent..."
                className="loan_com_search w-full isBorder"
                value={searchTerm}
                onChange={handleSearchAgent}
              />
            </div>
            {filtAgentList?.length > 0 ? (
              <>
                <Radio.Group
                  className="w-full"
                  defaultValue={
                    selectedAgent.activeAgent
                      ? selectedAgent.activeAgent
                      : selectedAgent.defaultAgent
                  }
                >
                  <div className="flex flex-col gap-[10px] mt-[20px]">
                    {filtAgentList.map((item, idx) => {
                      const agent = item.agentinfo;
                      return (
                        <label
                          htmlFor={`agent${idx}`}
                          className="block rounded-[8px] p-[12px] border border-[#E0E0E0] flex items-start cursor-pointer relative"
                          key={idx}
                        >
                          <div className="absolute top-[5px] right-[5px]">
                            <Popover content={"Coming Soon"}>
                              <img src="/images/fi_info3.svg" alt="info" />
                            </Popover>
                          </div>
                          <Radio
                            id={`agent${idx}`}
                            value={item}
                            onChange={handleRadChange}
                            className="mt-[24px]"
                          />
                          <div className="flex-[1] flex">
                            <div className="h-[70px] w-[70px] rounded-[4px] border border-[#E9E9E9] mr-[15px] p-[7px]">
                              <img
                                src={`${IMAGE_BASE_URL}/${agent.icon}`}
                                className="
                                                    h-full w-full object-contain"
                                alt="log"
                              />
                            </div>
                            <div className="flex-[1]">
                              <div className="mb-[4px] text-[#27272B] text-[15px] font-[700] flex items-center gap-[13px]">
                                {agent.name}
                                {agent.hasPremium || agent.featured ? (
                                  <span className="inline-block">
                                    {agent.hasPremium ? (
                                      <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500] mr-[10px]">
                                        <img
                                          src="/images/prem_icon.svg"
                                          className="w-[16px]"
                                          alt="star"
                                        />{" "}
                                        <span className="relative top-[1px]">
                                          Premium
                                        </span>
                                      </span>
                                    ) : null}
                                    {agent.featured ? (
                                      <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500]">
                                        <img
                                          src="/images/star.svg"
                                          className="w-[16px]"
                                          alt="star"
                                        />{" "}
                                        <span className="relative top-[1px]">
                                          Featured
                                        </span>
                                      </span>
                                    ) : null}
                                  </span>
                                ) : null}
                              </div>
                              <div className="flex gap-[10px_20px] justify-between items-center flex-wrap">
                                <div>
                                  <span className="text-[#787486] block text-[12px] mb-[2px]">
                                    Dealer Commission
                                  </span>
                                  <span className="text-[#263238] text-[13px] font-[600]">
                                    {Number(item.dealerCommision)}% ($
                                    {Number(item.yearbonusAmount)})
                                  </span>
                                </div>
                                <div>
                                  <span className="text-[#787486] block text-[12px] mb-[2px]">
                                    Bonus Amount
                                  </span>
                                  <span className="text-[#263238] text-[13px] font-[600]">
                                    {item.dealerbonusinfo != null && item.dealerbonusinfo?.qualifying_loan_amounts !== undefined
                                      ? GetBonusValue(item?.dealerbonusinfo)
                                      : "NA"}
                                  </span>
                                </div>
                                <div>
                                  <span className="text-[#787486] block text-[12px] mb-[2px]">
                                    Admin Fee
                                  </span>
                                  <span className="text-[#263238] text-[13px] font-[600]">
                                    ${Number(item.adminfee)}
                                  </span>
                                </div>
                                <div className="w-full">
                                  <span className="text-[#787486] block text-[12px] mb-[2px]">
                                    Total Commission
                                  </span>
                                  <span className="text-[#263238] text-[13px] font-[600]">
                                    {item.dealerbonus > 0
                                      ? `$${item.dealerbonus} + `
                                      : ""}{" "}
                                    ${Number(item.yearbonusAmount)}{" "}
                                    {item.adminfee > 0
                                      ? "- $" + Number(item.adminfee)
                                      : ""}{" "}
                                    {item.dealerbonus > 0 || item.adminfee > 0
                                      ? "= " +
                                      (Number(item.dealerbonus) +
                                        Number(item.yearbonusAmount) -
                                        Number(item.adminfee) >=
                                        0
                                        ? "$" +
                                        (Number(item.dealerbonus) +
                                          Number(item.yearbonusAmount) -
                                          Number(item.adminfee))
                                        : "-$" +
                                        Math.abs(
                                          Number(item.dealerbonus) +
                                          Number(item.yearbonusAmount) -
                                          Number(item.adminfee)
                                        ))
                                      : ""}{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                      );
                    })}
                  </div>
                </Radio.Group>
                <div className="mt-[50px]">
                  <Button
                    type="primary"
                    className="ag_confirm_btn"
                    onClick={updateSelAgent}
                  >
                    Confirm
                  </Button>
                  <Button
                    className="ag_cancel_btn"
                    onClick={() => setselAgentPop(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </>
            ) : (
              <div className="flex flex-col gap-[10px] mt-[20px]">
                No Agents Found..!
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelAgentPopup;
